import "./ProfileButton.scss";
import React from "react";
import avatarImage from "../../assets/images/avatar.webp";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const ProfileButton: React.FC = () => {
  const navigate = useNavigate();
  const { userProfile, isAuthLoading } = useAuth();

  // Helper function to format role name for display
  const formatRoleName = (roleName: string) => {
    // Special case for ROLE_CLIENT_ADMIN
    if (roleName === "ROLE_CLIENT_ADMIN") {
      return "Enterprise Admin";
    }

    return roleName
      .replace("ROLE_", "")
      .split("_")
      .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
      .join(" ");
  };

  // Show loading state while profile is being fetched
  if (isAuthLoading || !userProfile) {
    return (
      <div className="profile-button relative inline-block">
        <div className="flex items-center space-x-3">
          <div className="h-[45px] w-[45px] rounded-full bg-gray-200 animate-pulse"></div>
          <div className="text-left">
            <div className="h-4 w-24 bg-gray-200 rounded animate-pulse mb-1"></div>
            <div className="h-3 w-20 bg-gray-200 rounded animate-pulse"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="profile-button relative inline-block"
      title="Click to view profile"
    >
      <button
        onClick={() => navigate("/profile")}
        className="flex items-center space-x-3 focus:outline-none"
      >
        <img
          src={avatarImage}
          alt="Profile"
          className="h-[45px] w-[45px] rounded-full"
        />
        <div className="text-left">
          <div className="font-[500] text-[16px] text-mainText overflow-hidden truncate w-[129px]">
            {userProfile.userFullName}
          </div>
          <div className="text-[14px] text-subText leading-[16px]">
            {formatRoleName(userProfile.role.name)}
          </div>
        </div>
      </button>
    </div>
  );
};

export default ProfileButton;
